import { createSlice } from '@reduxjs/toolkit';

import type { HelpAsset } from '@/types';

export interface HelpState {
  helpData: HelpAsset[];
}

const initialState: HelpState = {
  helpData: [],
};

export const helpSlice = createSlice({
  name: 'help',
  initialState,
  reducers: {
    setHelpData: (state, { payload }) => {
      state.helpData = payload;
    },
  },
});

export const {
  reducer: helpReducer,
  actions: { setHelpData },
} = helpSlice;
